module.exports = __webpack_public_path__ + "static/media/back.ff24a4dc.svg";